import Vue from 'vue'
import axios from 'axios'

// «Склади свою піцу»: товар-основа (томатний соус, сир) прихований з меню, тож беремо його тим самим запитом, що й застосунок.
// Як CUSTOM_PIZZA_ID_BY_LOCATION_CITY_ID у бекенді, але лише Луцьк: київська основа (130) не налаштована
const CITIES = [1];

export function loadCustomPizza() {
    const cityId = Number(JSON.parse(localStorage.getItem('locationCityId')));
    if (!CITIES.includes(cityId)) return Promise.resolve(null);
    return axios.get(`${Vue.prototype.SERVER_URL}/api/mobile/custom-pizza`, { params: { location_city_id: cityId } })
        .then(response => {
            const pizza = response.data;
            // Без основи з ціною кнопки немає — як і без запиту
            return pizza && pizza.id && pizza.category_id == 1 && Number(pizza.price_30) > 0 ? pizza : null;
        })
        .catch(() => null);
}
